export default {
  data() {
    return {
      channelIcons: [
        'fas fa-envelope',
        'fas fa-comments',
        'fas fa-phone fa-rotate-90',
        'fas fa-robot',
        'fas fa-user',
        'fas fa-user',
        'fas fa-envelope',
        'fas fa-comments',
        'fab fa-whatsapp',
        'fas fa-home',
        'fas fa-robot',
      ],
      channelIconsById: {
        1: 'fas fa-envelope',
        2: 'fas fa-comments',
        3: 'fas fa-phone fa-rotate-90',
        4: 'fas fa-robot',
        5: 'fas fa-user',
        6: 'fas fa-user',
        7: 'fab fa-whatsapp',
        8: 'fas fa-envelope',
        9: 'fas fa-comments',
        10: 'fas fa-home',
        12: 'fas fa-robot',
      },
      name: [
        'Email',
        'Sms',
        'Ivr',
        'Bot',
        'Call - discador',
        'Call - individual',
        'Whatsapp',
        'Email',
        'Sms',
        'Visitas',
        'Chatbot',
      ],
      channelObjects: [
        {
          id: 1,
          channel: 'email',
          name: 'Email',
          icon: 'fas fa-envelope',
        },
        {
          id: 2,
          channel: 'sms',
          name: 'Sms',
          icon: 'fas fa-comments',
        },
        {
          id: 3,
          channel: 'ivr',
          name: 'Ivr',
          icon: 'fas fa-phone fa-rotate-90',
        },
        {
          id: 4,
          channel: 'bot',
          name: 'Bot',
          icon: 'fas fa-robot',
        },
        {
          id: 5,
          channel: 'human',
          name: 'Call - discador',
          icon: 'fas fa-user',
        },
        {
          id: 6,
          channel: 'manual_human',
          name: 'Call - individual',
          icon: 'fas fa-user',
        },
        {
          id: 7,
          channel: 'whatsapp',
          name: 'Whatsapp (Chatcenter)',
          icon: 'fab fa-whatsapp',
        },
        /* {
          id: 8,
          channel: 'in_email',
          name: 'Email (Chatcenter)',
          icon: 'fas fa-envelope',
        },
        {
          id: 9,
          channel: 'in_sms',
          name: 'Sms (Chatcenter)',
          icon: 'fas fa-comments',
        }, */
        {
          id: 10,
          channel: 'visit',
          name: 'Visitas',
          icon: 'fas fa-home',
        },
        {
          id: 11,
          channel: 'chatbot',
          name: 'ChatBot',
          icon: 'fas fa-robot',
        },
        /* {
          id: 12,
          channel: 'out_sms',
          name: 'Sms (Respuesta Chatcenter)',
          icon: 'fas fa-comments',
        },
        {
          id: 13,
          channel: 'out_whatsapp',
          name: 'Whatsapp (Respuesta Chatcenter)',
          icon: 'fab fa-whatsapp',
        }, */
      ],
    };
  },
  methods: {
    showIconChannel(channelId) {
      return this.channelIconsById[channelId];
    },
    showNameChannel(channelId, transform = null) {
      let name = this.name[channelId - 1];
      if (transform) {
        if (transform === 'upperAll') {
          name = name.toUpperCase();
        } else if (transform === 'lowerAll') {
          name = name.toLowerCase();
        }
      }
      return name;
    },
    getChannelField(field, value, toReturn) {
      const index = this.channelObjects.findIndex(item => item[field] === value);
      if (index !== -1) {
        return this.channelObjects[index][toReturn];
      }
      return 0;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/channels.js